import { connect, ConnectedProps } from 'react-redux';

import { actions } from 'src/routes/IndividualDashboard/modules/dashboard';
import { RootState } from 'src/redux/store';
import { selectFilteredNSDevices } from 'src/routes/NursesStation/components/RoomsAndBeds/Connector';
import { sortRoomsAndBedsWithEmptyString } from 'src/utils/sorters/utils';

export const selectDefaultPatientId = (state: RootState) => {
  const nsDevices = selectFilteredNSDevices(state).sort((a, b) =>
    sortRoomsAndBedsWithEmptyString(
      a.roomName,
      a.bedName,
      b.roomName,
      b.bedName,
      { numeric: true },
    ),
  );

  return nsDevices.find(device => device.patientId && device.patientName)
    ?.patientId;
};

const mapStateToProps = (state: RootState) => ({
  defaultPatientId: selectDefaultPatientId(state),
});

const mapActionCreators = {
  onLoadIndividualDashboard: actions.onLoadIndividualDashboard,
  individualDashboardUnmounted: actions.individualDashboardUnmounted,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
